import { tokens, colorOrToken } from '@cast/design-system';
import { clusterColors } from '@cast/features-cluster-ui';

const { theme } = tokens;

/** Chart series colors — DS semantic data tokens (light/dark aware). */
export const clusterDashboardChartColors = {
  blue: theme.data.blue500,
  blueSubtle: theme.data.blue100,
  redSubtle: theme.data.red100,
  redStrong: theme.data.red500,
  healthy: theme.data.green500,
  breached: theme.data.red400,
  /** Node lifecycle — match Compute Spend / nodeTypeColors. */
  onDemand: theme.data.blue300,
  spot: theme.data.indigo800,
  fallback: theme.data.yellow400,
} as const;

/** Resource gauge segment colors — locked to shared clusterColors. */
export const clusterDashboardResourceColors = {
  used: clusterColors.used,
  allocatableBorder: clusterColors.allocatable,
  requested: clusterColors.requested,
  overhead: clusterColors.overhead,
  gpuIdle: clusterColors.idle,
  gpuNotUsed: theme.data.red400,
  segmentUsed: clusterColors.used,
  segmentRequested: clusterColors.requested,
  segmentAllocatable: theme.data.grey200,
  segmentOverhead: clusterColors.overhead,
  segmentGpuIdle: theme.data.yellow100,
  segmentGpuNotUsed: clusterColors.notUsed,
  benchmark: theme.data.grey700,
  progressTrack: theme.bg.structural.surfaceSubtle,
} as const;

/** Typography variants aligned with dashboard layouts. */
export const dashboardTypography = {
  resourceTitle: 'h6',
  sectionTitle: 'A1',
  metricLg: 'h4',
  metricXs: 'A1',
  labelMd: 'L12M',
  labelSm: 'L12R',
} as const;

/** Chip sx overrides — mirrors apps/console cluster dashboard LabelChip usage. */
export const clusterDashboardChipSx = {
  projectName: {
    backgroundColor: colorOrToken(
      'grey.200',
      tokens.theme.bg.categorical.greySubtle
    ),
    color: colorOrToken('grey.700', tokens.theme.fg.categorical.onGreySubtle),
    textTransform: 'none',
  },
  metadataLabel: {
    // MetadataChip uses LabelChip (L10M), which forces uppercase — Figma uses sentence case (P10M).
    '& .Ds-LabelChip-Label': {
      textTransform: 'none',
      letterSpacing: 'normal',
    },
  },
} as const;
